import { gql } from '@apollo/client';

export const GET_TOOLS_BY_IDS = gql`
  query GetToolsByIds($ids: [ID!]!, $date: ISO8601Date!) {
    toolsByIds(ids: $ids) {
      id
      name
      description
      primaryImageUrl
      pricePerDayCents
      city
      postalCode
      nextAvailableDate(date: $date)
      ratingAverage
      reviewCount
      categories {
        id
        name
        code
      }
    }
  }
`;
